import { customRef } from 'vue';

export default function<T>(key: string, defaultValue: T | null = null) {
  return customRef<T | null>((track, trigger) => ({
    get: (): T | null => {
      // Track update.
      track();

      // Only continue on client-side.
      if (typeof window === 'undefined') {
        return defaultValue;
      }

      // Try and retrieve value from local storage.
      const value: string | null = localStorage.getItem(key);
      if (value === null) {
        return defaultValue;
      }

      try {
        // Parse and return value.
        return JSON.parse(value) as T;
      } catch (error) {
        // Or return a default value on failure.
        return defaultValue;
      }
    },
    set: (value: T | null): void => {
      // Only continue on client-side.
      if (typeof window === 'undefined') {
        trigger();
        return;
      }

      // Set or remove key.
      value === null
        ? localStorage.removeItem(key)
        : localStorage.setItem(key, JSON.stringify(value));

      // Trigger update.
      trigger();
    },
  }));
}
